import { useDeleteChannelChannelDeleteDeleteMutation } from '@shared/api';
import { useState } from 'react';

export const useDeleteChannel = () => {
  const [deleteChannelMutation, { isLoading }] = useDeleteChannelChannelDeleteDeleteMutation();
  const [loadingChannelId, setLoadingChannelId] = useState<number | null>(null);

  const deleteChannel = async (channelId: number) => {
    setLoadingChannelId(channelId);
    try {
      await deleteChannelMutation({
        channelId,
      }).unwrap();
    } catch (error) {
    } finally {
      setLoadingChannelId(null);
    }
  };

  return {
    deleteChannel,
    isLoading,
    loadingChannelId,
  };
};
